module.exports = __webpack_public_path__ + "img/jj1.a62ac914.png";